import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#2C7EDF"
}), React.createElement("path", {
  d: "M12.0498 5.70959V13.4523",
  stroke: "white",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M12.05 19.1535C12.765 19.1535 13.3446 18.5739 13.3446 17.8589C13.3446 17.1439 12.765 16.5643 12.05 16.5643C11.335 16.5643 10.7554 17.1439 10.7554 17.8589C10.7554 18.5739 11.335 19.1535 12.05 19.1535Z",
  fill: "white"
})), "IconMessageNotification");